/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The action which is to be performed on a container within an order.
 */
export enum EnumContainerOrderAction {
    /**
     * Not defined
     */
    NotDefined = 0,
    /**
     * The container is placed at the site
     */
    Place = 1,
    /**
     * The container is collected from the site
     */
    Collect = 2,
    /**
     * The container is emptied where it stands
     */
    Empty = 3,
}
